// extracted by mini-css-extract-plugin
module.exports = {"recommendedProductOverride":"recommendedProduct-module__recommendedProductOverride___2TgE5"};